export default function TermsPage() {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100vw',
        height: '100vh',
        overflow: 'hidden',
      }}
    >
      <iframe
        width="100%"
        height="100%"
        title="TERMS PAGE"
        src="https://docs.google.com/document/d/e/2PACX-1vRsMJNbICHVgcO2O7nPTeffW-Ym02qi1oIeZJdFlpS-KSxW297qZz1GTOYiq9VKM0htkOscSRbzbSKe/pub?embedded=true"
      ></iframe>
    </div>
  )
}
